export type StatusEvent =
	| 'published'
	| 'scheduled'
	| 'draft'
	| 'expired'
	| 'finished'

export type CalendarEvent = {
	id: number
	title: string
	status: StatusEvent
	organization_icon: string
	organization_name: string
	description: string
	publish_date: string
	expire_date?: string | null
	assets?: Array<string>
	isContent?: boolean
	isPush?: boolean
	has_notification?: boolean
	card_expirated?: boolean
	release_date?: string | null
	expiration_date?: string | null
	repeat_start_date?: string | null
}

export type CalendarDay = {
	date: string
	isCurrentMonth: boolean
	events: CalendarEvent[]
	isSelected: boolean
	isToday: boolean
}

export function classNames(
	...classes: Array<string | boolean | undefined>
): string {
	return classes.filter(Boolean).join(' ')
}

export type ViewTypeCalendar = 'week' | 'month'
